<template>
	<BaseCmsPage>
		<WebshopCheckoutLayout>
			<template #header>
				<WebshopCheckoutHeader :step="2" />
			</template>

			<template #wcCol2>
				<div class="step-form-cnt step-form1-cnt">
					<div class="step-form-cnt-inner">
						<WebshopStep :step="1" :title="true" />
						<ClientOnly>
							<BaseWebshopCustomerForm class="form step1-form form-animated-label" v-slot="{loading, fields, errors}" data-autofocus>
								<div class="step1-form-inner">
									<template v-if="Object.keys(errors)?.length">
										<BaseCmsLabel tag="div" class="global-error" code="form_validation_error" data-scroll-to-error />
									</template>
									<BaseFormField v-for="field in fields" :key="field.name" :item="field" v-slot="{errorMessage, floatingLabel, isTouched, value}">
										<p class="field" :class="['field-' + field.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]">
											<BaseFormInput :readonly="loading" />
											<label :for="field.name"><BaseCmsLabel :code="field.name" /></label>
											<BaseCmsLabel tag="span" class="phone-note" code="phone_note" v-if="field.name == 'phone'" />
											<span class="error" v-show="errorMessage" v-html="errorMessage" />
										</p>
									</BaseFormField>
								</div>

								<button class="btn btn-orange checkout-btn-next-step noarrow" type="submit" :class="{'loading': loading}" :disabled="loading"><UiLoader v-if="loading" /><BaseCmsLabel code="next_step" /></button>
							</BaseWebshopCustomerForm>
						</ClientOnly>
					</div>
				</div>

				<div class="checkout-steps">
					<WebshopStep :step="2" />
					<WebshopStep :step="3" />
					<WebshopStep :step="4" />
				</div>
			</template>
		</WebshopCheckoutLayout>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	.phone-note{display: block; padding: 8px 0 0 20px; font-size: 12px; line-height: 1.2; color: var(--darkGray);}
	:deep(.location-autocomplete-container){position: absolute; top: 56px;}
</style>